export default "__VITE_ASSET__BGF6BFns__"